import React from 'react'
import desembarquePas from '../assets/images/desembarque/desembarque-pas.png'
import desembarqueAuto from '../assets/images/desembarque/desembarque-auto.png'
import desembarqueCarga from '../assets/images/desembarque/desembarque-carga.png'
import equipaje from '../assets/images/desembarque/equipaje.webp'
import autobus from '../assets/images/desembarque/autobus.jpg'

import '../css/alllegar.scss'
import { Link } from 'react-router-dom'


export default function Alllegar() {
  return (
    <>
     <section className='al-llegar'>

        <div className='container'>
                 {/* PROCESO 
          <section className='al-proceso'>

            <div className='al-proceso-title'>
              <h2>Puertos y autoridades</h2>
            </div>

            <div className='al-proceso-grid'>

              <div className='al-proceso-box'>
                <div className='al-proceso-icon'>
                  <i class="fi fi-rs-compress-alt"></i>
                 
                </div>

                <h3>Proceso de desembarque</h3>

                <p>
                  Sigue las instrucciones del personal para una salida
                  segura y ordenada de la embarcación.
                </p>
              </div>

              <div className='al-proceso-box'>
                <div className='al-proceso-icon'>
                  <i class="fi fi-rs-search"></i>
                </div>

                <h3>Revisiones</h3>

                <p>
                  Preparación para inspecciones de autoridades
                  portuarias, aduanas o seguridad sanitaria.
                </p>
              </div>

              <div className='al-proceso-box'>
                <div className='al-proceso-icon'>
                  <i class="fi fi-rs-leave"></i>
                </div>

                <h3>Salida del puerto</h3>

                <p>
                  Direcciones claras para abandonar el recinto
                  portuario y continuar tu viaje.
                </p>
              </div>

            </div>

          </section>*/}


          {/* DESEMBARQUE */}
          <section className='al-section'>
            <div className='al-section-title'>
              <h2><i class="fi fi-rs-leave"></i> <span>Desembarque</span></h2>
            </div>

            <div className='al-card-grid'>

              <div className='al-card'>
                <img src={desembarquePas} alt='' />

                <div className='al-card-body'>
                  <h3>Desembarque de pasajeros</h3>

                  <p>
                    ¿Viajas como pasajero a pie con Baja Ferries?
                    Descubre cómo desembarcar fácil, rápido y seguro.
                  </p>

                  <Link to="/desembarque-pasajero">
                    Ver más
                  </Link>
                </div>
              </div>
                 

              <div className='al-card'>
                <img src={desembarqueAuto} alt='' />

                <div className='al-card-body'>
                  <h3>Desembarque con automóvil</h3>

                  <p>
                    ¿Viajas en auto con Baja Ferries?
                    Te mostramos cómo hacerlo fácil y seguro siguiendo
                    las señales de tripulación.
                  </p>

                  <Link to="/desembarque-con-automovil">
                    Ver más
                  </Link>
                </div>
              </div>

              <div className='al-card'>
                <img src={desembarqueCarga} alt='' />

                <div className='al-card-body'>
                  <h3>Unidades de carga</h3>

                  <p>
                    Información específica para conductores de carga
                    sobre el proceso de salida coordinada y pesaje final.
                  </p>

                  <Link to="/desembarque-con-unidades-de-carga">
                    Ver más
                  </Link>
                </div>
              </div>

            </div>
          </section>

          {/* EQUIPAJE */}
          <section className='al-section'>
            <div className='al-section-title'>
              <h2><i class="fi fi-rs-luggage-rolling"></i> <span>Equipaje y Facturación</span></h2>
            </div>

            <div className='al-card-grid'>

              <div className='al-card'>
                <img src={equipaje} alt='' />

                <div className='al-card-body'>
                  <h3>Recepción de equipaje</h3>

                  <p>
                    Detalles sobre dónde y cómo recoger tu equipaje
                     al llegar al puerto de destino.
                  </p>

                  <Link to="/recepcion-equipaje">
                    Ver más
                  </Link>
                </div>
              </div>
             
              <div className='al-card'>
                <img src={desembarquePas} alt='' />

                <div className='al-card-body'>
                  <h3>Revisiones de autoridades</h3>

                  <p>
                    Información importante sobre trámites de aduana,
                    revisiones fitosanitarias o pesaje oficial.
                  </p>

                  <Link to="/revision-autoridades">
                    Ver más
                  </Link>
                </div>
              </div>

              <div className='al-card'>
                <img src={autobus} alt='' />

                <div className='al-card-body'>
                  <h3>Conecta tu viaje</h3>

                  <p>
                    Opciones de traslado terrestre con aliados como Élite y Águila para continuar tu viaje.
                  </p>

                  <Link to="/conecta-tu-viaje">
                    Ver más
                  </Link>
                </div>
              </div>
            </div>
          </section>

   

        </div>

         {/* AYUDA */}
        <section className='al-ayuda'>
          <div className='container'>

            <div className='al-ayuda-box'>

              <div className='al-ayuda-text'>
                <h2>¿Necesitas ayuda adicional?</h2>

                <p>
                  Nuestro equipo de soporte está disponible para resolver
                  cualquier duda sobre tu llegada o trámites pendientes.
                </p>

                <div className='al-ayuda-info'>

                  <div>
                    <label>Centro de atención</label>
                    <span>800 337 7437</span>
                  </div>

                  <div>
                    <label>Correo electrónico</label>
                    <span>contactcenter@bajaferries.com.mx</span>
                  </div>

                </div>
              </div>

              <div className='al-ayuda-button'>                
                <a href='https://www.bajaferries.com.mx/preguntas-frecuentes' target='_blank' rel='noopener noreferrer'>Preguntas frecuentes </a>
              </div>

            </div>

          </div>
        </section>


        {/* FEEDBACK */}
        <section className='al-feedback'>
          <div className='container al-feedback-content'>

            <div>
              <h3>¿FUE ÚTIL ESTA INFORMACIÓN?</h3>

              <p>
                Ayúdanos a mejorar tu experiencia de viaje.
              </p>
            </div>

            <div className='al-feedback-buttons'>
              <a href='https://buzon-bf-quejas-2026.cxconversa.workers.dev/' target='_blank' rel='noopener noreferrer'>Buzón de quejas y sugerencias  </a>            
            </div>

          </div>
        </section>

       

      </section>

    
    
    </>
  )
}
